import { createFileRoute } from '@tanstack/react-router'
import { loaderSeason } from '~/features/compensation/queries'
import { NoFinanceAccess } from '~/features/finance/parts'
import { sponsorsQuery } from '~/features/finance/queries'
import { SponsorsPage } from '~/features/finance/SponsorsPage'
import { useCan } from '~/lib/session'

export const Route = createFileRoute('/_app/verein/sponsoren/')({
  loader: async ({ context }) => {
    const s = await loaderSeason(context.queryClient)
    if (s?.canRead) await context.queryClient.ensureQueryData(sponsorsQuery(s.season))
  },
  component: function Sponsoren() {
    return useCan()('finance.read') ? <SponsorsPage /> : <NoFinanceAccess title="Sponsoren" />
  },
})
